export const resources = {
    common: 'common',
    edit: 'edit',
    attachment: 'attachment',
    errors: 'errors',
}

export const translations = {
    common: {
        edit: 'edit',
        attachment: 'attachment',
        backToSmartform: 'backToSmartform',
        predefined: 'predefined',
        library: 'library',
        preview: 'preview',
        previewPDF: 'previewPDF',
        previewHTML: 'previewHTML',
        pdfPreview: 'pdfPreview',
        htmlPreview: 'htmlPreview',
        splitScreen: 'splitScreen',
        singleScreen: 'singleScreen',
        refresh: 'refresh',
        refreshWithLatest: 'refreshWithLatest',
        refreshDisabled: 'refreshDisabled',
        loading: 'loading',
        publish: 'publish',
        discard: 'discard',
        previous: 'previous',
        next: 'next',
        ok: 'ok',
        cancel: 'cancel',
        delete: 'delete',
        openMenu: 'openMenu',
        retry: 'retry',
        exit: 'exit',
        reason: 'reason',
        moreoptions: 'moreoptions',
        pageBreak: 'pageBreak',
        addPageBreak: 'addPageBreak',
        addPageBreakBefore: 'addPageBreakBefore',
        addPageBreakAfter: 'addPageBreakAfter',
        removePageBreak: 'removePageBreak',
        removePageBreakBefore: 'removePageBreakBefore',
        removePageBreakAfter: 'removePageBreakAfter',
        blockHelpText: 'blockHelpText',
        paste: 'paste',
        selectenoption: 'selectenoption',
        none: 'none',
        authentication: {
            authenticate: 'authentication.authenticate',
            authenticationRequired: 'authentication.authenticationRequired',
            forbidden: 'authentication.forbidden',
            authenticateMessage: 'authentication.authenticateMessage',
            authFailedMessage: 'authentication.authFailedMessage'
        },
        format: {
            bold: 'format.bold',
            italic: 'format.italic',
            underline: 'format.underline',
            alignment: 'format.alignment',
            alignLeft: 'format.alignLeft',
            alignCenter: 'format.alignCenter',
            alignRight: 'format.alignRight',
            alignJustify: 'format.alignJustify',
            list: 'format.list',
            bulletedList: 'format.bulletedList',
            numberedList: 'format.numberedList',
            font: 'format.font',
            size: 'format.size',
            fontSize: 'format.fontSize',
            openFormatMenu: 'format.openFormatMenu',
            undo: 'format.undo',
            redo: 'format.redo',
        }
    },
    edit: {
        search: 'search',
        closePanel: 'closePanel',
        predefined: {
            predefinedText: 'predefined.predefinedText',
            filter: 'predefined.filter',
            blank: 'predefined.blank',
        },
        "library": {
            textLibrary: 'library.textLibrary',
            selectLanguage: 'library.selectLanguage',
            texts: 'library.texts',
            page: 'library.page',
            of: 'library.of',
            all: 'library.all',
            group: 'library.group',
            language: 'library.language',
            validFrom: 'library.validFrom',
            validTo: 'library.validTo',
            name: 'library.name',
            createdTime: 'library.createdTime',
            createdByUserName: 'library.createdByUserName',
            modifiedTime: 'library.modifiedTime',
            modifiedByUserName: 'library.modifiedByUserName',
            sortby: 'library.sortby',
            ascending: 'library.ascending',
            descending: 'library.descending',
            copyText: 'library.copyText',
            textHasExpired: 'library.textHasExpired',
            copied: 'library.copied',
            insertTextFromLibrary: 'library.insertTextFromLibrary',
            copyFullTextToClipboard: 'library.copyFullTextToClipboard',
            copyPartialTextToClipboard: 'library.copyPartialTextToClipboard',
            danish: 'library.danish',
            english: 'library.english',
            finnish: 'library.finnish',
            norwegian: 'library.norwegian',
            swedish: 'library.swedish',
        },
        "distribution": {
            "distribution": "distribution.distribution",
            "centralDistribution": "distribution.centralDistribution",
            "localPrint": "distribution.localPrint",
            "email": "distribution.email",
            "archiveOnly": "distribution.archiveOnly",
            "successDocumentPublishment": "distribution.successDocumentPublishment",
            "successDocumentDistribution": "distribution.successDocumentDistribution",
            "generatingPdf": "distribution.generatingPdf",
            "pleaseWaitProcessing": "distribution.pleaseWaitProcessing",
            "download": "distribution.download",
            "print": "distribution.print",
            "close": "distribution.close"
        },
        "discard": {
            "discardDocument": "discard.discardDocument",
            "areYouSureToDiscardDocument": "discard.areYouSureToDiscardDocument",
        },
        "insertPoint": {
            "insertedText": "insertPoint.insertedText",
        },
        "inputFieldValidation": {
            "required": "inputFieldValidation.required",
            "atLeast": "inputFieldValidation.atLeast",
            "atMost": "inputFieldValidation.atMost",
            "characterRequired": "inputFieldValidation.characterRequired",
            "invalid": "inputFieldValidation.invalid",
        },
        "mandatoryFieldBanner": {
            "message": "mandatoryFieldBanner.message",
            "browse": "mandatoryFieldBanner.browse",
            "moveDown": "mandatoryFieldBanner.moveDown",
            "moveUp": "mandatoryFieldBanner.moveUp",
        },
        "breakTable": {
            "insertRowAbove": "breakTable.insertRowAbove",
            "insertRowBelow": "breakTable.insertRowBelow",
            "deleteRow": "breakTable.deleteRow",
            "moveUp": "breakTable.moveUp",
            "moveDown": "breakTable.moveDown"
        }
    },
    attachment: {
        addFromLibrary: 'addFromLibrary',
        uploadFile: 'uploadFile',
        name: 'name',
        description: 'description',
        actions: 'actions',
        attachmentLibrary: 'attachmentLibrary',
        search: 'search',
        preview: 'preview',
        back: 'back',
        save: 'save',
        moveDown: 'moveDown',
        moveUp: 'moveUp',
        delete: 'delete',
        unselectAllAttachments: 'unselectAllAttachments',
        selectAllAttachments: 'selectAllAttachments',
        unselectAttachment: 'unselectAttachment',
        selectAttachment: 'selectAttachment',
        previewAttachment: 'previewAttachment',
    },
    errors: {
        failLoadDxmlFile: "failLoadDxmlFile",
        failSaveDocument: "failSaveDocument",
        failLoadFile: "failLoadFile",
        failLoadData: "failLoadData",
        failSearch: "failSearch",
        failSearchAttachment: "failSearchAttachment",
        failLoadFileExtension: "failLoadFileExtension",
        failLoadFileExtensionIsNotSupport: "failLoadFileExtensionIsNotSupport",
        disableDistributionError: "disableDistributionError",
        enableDistributionError: "enableDistributionError",
        selectFileTooLarge: "selectFileTooLarge",
        inactiveDistributionList: "inactiveDistributionList",
        noActiveDistributionAlternatives: "noActiveDistributionAlternatives",
        publishErrorMsg: "publishErrorMsg",
    },
}